module.exports = __webpack_public_path__ + "static/media/office.36d907c9.jpeg";